<div class="modal-header ">
    <app-page-content-header 
        [pageTitle]="translate('PLEASERESETPASSWORD')"
        [isPopUp]="true"
        style="border: 0px !important; padding: 0px !important;"
    /> 
    <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
</div>
<div class="modal-body" [formGroup]="newPasswordForm">   
    <div *ngIf="errorMessage" class="bg-danger-subtle d-flex justify-content-between p-2 w-100">
        <div>
            <span class="text-danger-emphasis">
                <i [class]="icon"></i> {{errorMessageText}}
            </span>
        </div>
        <div>
            <button 
                type="button" 
                class="btn-close me-2 m-auto" 
                data-bs-dismiss="toast" aria-label="Close"
                (click)="close()" >
            </button>
        </div>
    </div>
    <app-input-static-fields 
        htmlCode="&#64;" 
        code=""
        [formGroup]="newPasswordForm"
        label="{{ translate('USERNAME') }}" 
        placeholder="Abc.caregenix.solution@gmail.com"
        [name]="'Email'"
        type="email"
        [formControlValue]="'email'"    
        [isReadonly]="true"
    />    
    <app-input-static-fields    
        code="fa fa-lock"
        [formGroup]="newPasswordForm"
        label="{{ translate('PASSWORD') }}" 
         [name]="'password'"
        type="password"
        maxlength="15"
        [formControlValue]="'password'"
        >
   
      <div class="password-strength" *ngIf="passwordStrength">
                <div class="block-container">
                <div class="strength-block" [ngClass]="{
                    'active': passwordStrengthPercentage >= 33,
                    'weak': passwordStrength === 'Weak',
                    'medium': passwordStrength === 'Medium',
                    'strong': passwordStrength === 'Strong'
                }"></div>
                <div class="strength-block" [ngClass]="{
                    'active': passwordStrengthPercentage >= 66,
                    'medium': passwordStrength === 'Medium' || passwordStrength === 'Strong'
                }"></div>
                <div class="strength-block" [ngClass]="{
                    'active': passwordStrengthPercentage >= 100,
                    'strong': passwordStrength === 'Strong'
                }"></div>
                </div>
                <span class="strength-text">{{ translate(passwordStrength) }}</span>
            </div>
        </app-input-static-fields>   
        <!-- ✅ Password Hint Displayed below the Password Field -->
            <div class="text-muted fs-13 passwordHint" >
            {{ translate('PASSWORDHINT') }}
            </div>
    <app-input-static-fields 
        code="fa fa-lock"
        [formGroup]="newPasswordForm"
        label="{{ translate('CONFIRMPASSWORD') }}" 
         [name]="'confirmPassword'"
        type="password"
        maxlength="15"
        [formControlValue]="'confirmPassword'"    
    />
     <!-- ✅ Password Hint Displayed below the Password Field -->
            <div class="text-muted fs-13 passwordHint" >
            {{ translate('PASSWORDHINT') }}
            </div>
    <div class=" py-3">
        <button 
          class="btn btn-lg w-100 btnChangePassword"
          type="submit"
          (click)="onSubmit()"
          [disabled]="newPasswordForm.invalid">Set Password</button>
    </div>
  
</div>